import { jsxs as o, jsx as e, Fragment as N } from "react/jsx-runtime";
import F, { useMemo as A, useEffect as E, useState as L, useRef as B, useCallback as I } from "react";
import { Alert as G, Collapse as _, useTheme as $, useMediaQuery as W, Box as u, ButtonGroup as V, Button as C, Typography as D, LinearProgress as J, Dialog as H, DialogContent as R, DialogTitle as j, DialogActions as U } from "@mui/material";
import { Box as q } from "@mui/system";
import { DataGrid as z, GridToolbarContainer as Z, GridToolbarExport as Q } from "@mui/x-data-grid";
import X from "@fullcalendar/react";
import Y from "@fullcalendar/daygrid";
import K from "@fullcalendar/timegrid";
import ee from "@fullcalendar/interaction";
import { ArrowBack as re, ArrowForward as te, CalendarViewMonth as ie, ViewWeek as oe, ViewDay as ne, Today as se } from "@mui/icons-material";
const le = (r, t) => /* @__PURE__ */ e(
  q,
  {
    onClick: () => t((i) => !i),
    sx: {
      display: "inline",
      textDecoration: "underline",
      cursor: "pointer"
    },
    children: "Enter it here."
  }
);
function Me({
  title: r,
  children: t,
  severity: i = "info",
  defaultCollapsed: n = !0,
  renderTrigger: s = le,
  ...h
}) {
  const [a, d] = F.useState(n);
  return /* @__PURE__ */ o(G, { sx: { mb: 2 }, severity: i, "data-cy": h["data-cy"], children: [
    r,
    " ",
    s == null ? void 0 : s(a, d),
    /* @__PURE__ */ e(_, { in: !a, timeout: "auto", unmountOnExit: !0, children: t })
  ] });
}
const ae = "Server-side sorting is enabled but no onSortModelChange handler was provided", de = "Server-side filtering is enabled but no onFilterModelChange handler was provided", ce = () => /* @__PURE__ */ e(Z, { children: /* @__PURE__ */ e(
  Q,
  {
    printOptions: { disableToolbarButton: !0 },
    csvOptions: { disableToolbarButton: !1 }
  }
) }), Te = ({
  rows: r,
  columns: t,
  pageSize: i = 100,
  page: n = 0,
  rowsPerPageOptions: s = [100, 200, 300],
  loading: h = !1,
  sortModel: a = [],
  totalRows: d = 0,
  dataCy: v = "",
  enableExport: b = !1,
  onSortModelChange: c,
  onFilterModelChange: f,
  onPageChange: g,
  onPageSizeChange: S,
  onRowClick: M
}) => {
  const y = i > d ? "client" : "server", w = A(() => r.map((m, T) => ({
    ...m,
    ...m.id === void 0 && { id: `${n}-${T}` }
  })), [r, n]), l = (m) => {
    g && g(m.page), S && m.pageSize !== i && S(m.pageSize);
  };
  E(() => {
    if (y === "server") {
      const m = t.some((O) => O.serverSortable), T = t.some(
        (O) => O.serverFilterable
      );
      if (m && !c)
        throw new Error(ae);
      if (T && !f)
        throw new Error(de);
    }
  }, [y, t, c, f]);
  const p = A(() => y === "client" ? t.map((m) => ({
    ...m,
    sortable: !0,
    filterable: !0
  })) : t.map((m) => ({
    ...m,
    sortable: m.serverSortable,
    filterable: m.serverFilterable
  })), [t, y]);
  return /* @__PURE__ */ e(
    z,
    {
      rows: w,
      slotProps: {
        row: {
          "data-cy": `${v}-row`
        }
      },
      "data-cy": `${v}-table`,
      columns: p,
      paginationModel: {
        pageSize: i,
        page: n
      },
      onPaginationModelChange: l,
      pageSizeOptions: s,
      loading: h,
      disableRowSelectionOnClick: !0,
      localeText: {
        noRowsLabel: "No data found"
      },
      sortModel: a,
      onSortModelChange: c,
      onFilterModelChange: f,
      onRowClick: M,
      slots: {
        toolbar: b ? ce : void 0
      },
      ...y === "server" ? {
        rowCount: d,
        paginationMode: "server",
        sortingMode: "server",
        filterMode: "server",
        keepNonExistentRowsSelected: !1,
        checkboxSelection: !1
      } : {
        paginationMode: "client",
        sortingMode: "client",
        filterMode: "client"
      },
      sx: {
        "& .MuiDataGrid-cell:focus": {
          outline: "none"
        },
        "& .MuiDataGrid-row:hover": {
          backgroundColor: "action.hover",
          cursor: "pointer"
        },
        bgcolor: "background.paper"
      }
    },
    `${n}-${i}`
  );
};
var ue = /* @__PURE__ */ ((r) => (r.AVAIL = "avail", r.SCHEDULE = "approvedSchedule", r.NO_AVAIL = "noAvail", r.TIME_OFF = "timeOff", r.HOLIDAY = "holiday", r.TRANSIENT = "transient", r.LESSON = "lesson", r))(ue || {});
const k = [
  Y,
  K,
  ee
], he = (r) => r.plugins ? [...k, ...r.plugins] : k, Oe = ({
  isLoading: r = !1,
  height: t = "900px",
  showViewSwitcher: i = !1,
  showHeader: n = !0,
  events: s,
  ...h
}) => {
  const a = $(), d = W(a.breakpoints.down("sm")), [v, b] = L(""), c = B(null);
  F.useEffect(() => {
    var p;
    const l = (p = c == null ? void 0 : c.current) == null ? void 0 : p.getApi();
    l && b(l.view.title);
  }, []);
  const f = (l) => {
    b(l.view.title);
  }, g = I(
    (l) => ({
      view: l.view,
      start: l.view.currentStart,
      end: l.view.currentEnd,
      startStr: l.view.currentStart.toISOString(),
      endStr: l.view.currentEnd.toISOString(),
      timeZone: l.getOption("timeZone") || "local"
    }),
    []
  ), S = () => {
    var p;
    const l = (p = c == null ? void 0 : c.current) == null ? void 0 : p.getApi();
    l && (l.prev(), f(g(l)));
  }, M = () => {
    var p;
    const l = (p = c == null ? void 0 : c.current) == null ? void 0 : p.getApi();
    l && (l.next(), f(g(l)));
  }, y = () => {
    var p;
    const l = (p = c == null ? void 0 : c.current) == null ? void 0 : p.getApi();
    l && (l.today(), f(g(l)));
  }, w = I((l) => {
    var m;
    const p = (m = c == null ? void 0 : c.current) == null ? void 0 : m.getApi();
    p && (p == null || p.changeView(l));
  }, []);
  return /* @__PURE__ */ o(N, { children: [
    /* @__PURE__ */ o(
      u,
      {
        sx: {
          display: n ? "flex" : "none",
          flexDirection: d ? "column" : "row",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 1,
          mb: 1
        },
        children: [
          /* @__PURE__ */ o(
            V,
            {
              variant: "contained",
              "aria-label": "Calendar navigation",
              disabled: r,
              children: [
                /* @__PURE__ */ e(C, { onClick: S, "data-testid": "calendar-prev-button", children: /* @__PURE__ */ e(re, {}) }),
                /* @__PURE__ */ e(C, { onClick: M, "data-testid": "calendar-next-button", children: /* @__PURE__ */ e(te, {}) })
              ]
            }
          ),
          /* @__PURE__ */ e(D, { sx: { fontSize: "22px", textAlign: "center" }, children: /* @__PURE__ */ e("strong", { children: v }) }),
          /* @__PURE__ */ o(u, { sx: { display: "flex", gap: 1 }, children: [
            i && /* @__PURE__ */ o(V, { variant: "contained", disabled: r, children: [
              /* @__PURE__ */ e(
                C,
                {
                  onClick: () => w("dayGridMonth"),
                  "data-testid": "calendar-month-button",
                  startIcon: /* @__PURE__ */ e(ie, {}),
                  children: "Month"
                }
              ),
              /* @__PURE__ */ e(
                C,
                {
                  onClick: () => w("timeGridWeek"),
                  "data-testid": "calendar-week-button",
                  startIcon: /* @__PURE__ */ e(oe, {}),
                  children: "Week"
                }
              ),
              /* @__PURE__ */ e(
                C,
                {
                  onClick: () => w("timeGridDay"),
                  "data-testid": "calendar-day-button",
                  startIcon: /* @__PURE__ */ e(ne, {}),
                  children: "Day"
                }
              )
            ] }),
            /* @__PURE__ */ e(
              C,
              {
                variant: "contained",
                disabled: r,
                startIcon: /* @__PURE__ */ e(se, {}),
                onClick: y,
                "data-testid": "calendar-today-button",
                children: "Today"
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ o(u, { position: "relative", children: [
      /* @__PURE__ */ e(
        X,
        {
          ref: c,
          height: t,
          headerToolbar: !1,
          datesSet: f,
          plugins: he(h),
          events: s,
          ...h
        }
      ),
      r && /* @__PURE__ */ o(
        u,
        {
          sx: {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            backgroundColor: "grey.200",
            opacity: 0.8,
            zIndex: 1
          },
          children: [
            /* @__PURE__ */ e(D, { children: "Loading..." }),
            /* @__PURE__ */ e(u, { sx: { width: "50%", maxWidth: "300px" }, children: /* @__PURE__ */ e(J, {}) })
          ]
        }
      )
    ] })
  ] });
};
function Ee(r = { isOpen: !1 }) {
  const [t, i] = L(r), n = I((h) => {
    i({ isOpen: !0, target: h });
  }, []), s = I(() => {
    i((h) => ({ ...h, isOpen: !1, target: void 0 }));
  }, []);
  return {
    ...t,
    openFor: n,
    close: s
  };
}
function P(r, t) {
  return r.target === void 0 ? null : t(r.target);
}
function Pe(r) {
  const { modal: t, children: i, ...n } = r;
  return /* @__PURE__ */ e(H, { ...n, open: t.isOpen, onClose: t.close, children: /* @__PURE__ */ e(R, { children: P(t, i) }) });
}
function Fe(r) {
  const {
    modal: t,
    title: i,
    isDisabled: n,
    onConfirm: s,
    children: h,
    ...a
  } = r;
  let { actionButtonLabel: d, cancelButtonLabel: v } = r;
  return d = d ?? "Delete", v = v ?? "Cancel", /* @__PURE__ */ o(H, { ...a, open: t.isOpen, onClose: t.close, children: [
    /* @__PURE__ */ e(j, { children: i }),
    /* @__PURE__ */ e(R, { children: P(t, h) }),
    P(t, (b) => /* @__PURE__ */ o(U, { children: [
      /* @__PURE__ */ e(
        C,
        {
          color: "primary",
          onClick: t.close,
          "data-cy": "confirmation-cancel-button",
          disabled: n,
          children: v
        }
      ),
      /* @__PURE__ */ e(
        C,
        {
          color: "primary",
          onClick: () => s(b),
          "data-cy": "confirmation-confirm-button",
          disabled: n,
          children: d
        }
      )
    ] }))
  ] });
}
const x = (r) => {
  const t = r.match(/(\d{1,2}):(\d{2})\s*(am|pm)?/i);
  if (!t)
    return 0;
  const [, i, n, s] = t, h = parseInt(i, 10) * 60 + parseInt(n, 10);
  if (s) {
    const a = s.toLowerCase();
    if (a === "pm" && i !== "12")
      return h + 12 * 60;
    if (a === "am" && i === "12")
      return h - 12 * 60;
  }
  return h;
}, pe = (r, t) => {
  const i = x(r);
  return x(t) - i;
}, me = (r, t, i) => {
  const s = pe(r, t) / 60 * 240;
  return Math.max(i, s);
}, ve = ({ gapMinutes: r }) => {
  const t = Math.floor(r / 60), i = r % 60, n = t > 0 ? `${t}h ${i}m gap` : `${i}m gap`;
  return /* @__PURE__ */ e(
    u,
    {
      sx: {
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "action.hover",
        borderBottom: "1px solid",
        borderColor: "divider"
      },
      children: /* @__PURE__ */ e(D, { variant: "caption", color: "text.secondary", children: n })
    }
  );
}, Ve = ({
  events: r,
  minEventHeight: t = 80,
  sidebarWidth: i = 60,
  minGapThreshold: n = 10
}) => {
  const s = A(
    () => [...r].sort(
      (a, d) => x(a.startTime) - x(d.startTime)
    ),
    [r]
  ), h = A(
    () => s.map(
      (a) => me(a.startTime, a.endTime, t)
    ),
    [s, t]
  );
  return /* @__PURE__ */ o(u, { sx: { display: "flex", width: "100%" }, children: [
    /* @__PURE__ */ e(
      u,
      {
        sx: {
          width: i,
          flexShrink: 0,
          borderRight: "1px solid",
          borderColor: "divider",
          position: "relative"
        }
      }
    ),
    /* @__PURE__ */ e(u, { sx: { flex: 1 }, children: s.map((a, d) => {
      const v = d > 0 && x(a.startTime) - x(s[d - 1].endTime) >= n, b = d > 0 ? x(a.startTime) - x(s[d - 1].endTime) : 0, c = h[d], f = d > 0 && s[d - 1].endTime === a.startTime, g = d < s.length - 1 && a.endTime === s[d + 1].startTime;
      return /* @__PURE__ */ o(F.Fragment, { children: [
        v && /* @__PURE__ */ e(u, { sx: { position: "relative" }, children: /* @__PURE__ */ e(ve, { gapMinutes: b }) }),
        /* @__PURE__ */ o(
          u,
          {
            sx: {
              display: "flex",
              minHeight: c,
              position: "relative",
              borderBottom: "1px solid",
              borderColor: "divider"
            },
            children: [
              /* @__PURE__ */ o(
                u,
                {
                  sx: {
                    position: "absolute",
                    left: -i,
                    width: i,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between"
                  },
                  children: [
                    f ? /* @__PURE__ */ e(u, { sx: { flexGrow: 0 } }) : /* @__PURE__ */ o(
                      u,
                      {
                        sx: {
                          display: "flex",
                          alignItems: "center",
                          position: "relative",
                          width: "100%"
                        },
                        children: [
                          /* @__PURE__ */ e(
                            D,
                            {
                              variant: "caption",
                              sx: {
                                width: i - 16,
                                pr: 1,
                                textAlign: "right"
                              },
                              children: a.startTime
                            }
                          ),
                          /* @__PURE__ */ e(
                            u,
                            {
                              sx: {
                                position: "absolute",
                                right: 0,
                                width: 16,
                                borderTop: "1px solid",
                                borderColor: "divider"
                              }
                            }
                          )
                        ]
                      }
                    ),
                    /* @__PURE__ */ o(
                      u,
                      {
                        sx: {
                          display: "flex",
                          alignItems: "center",
                          position: "relative",
                          width: "100%",
                          ...g && {
                            position: "absolute",
                            bottom: -11,
                            // Offset to align with the border
                            zIndex: 2
                          }
                        },
                        children: [
                          /* @__PURE__ */ e(
                            D,
                            {
                              variant: "caption",
                              sx: {
                                width: i - 16,
                                pr: 1,
                                textAlign: "right"
                              },
                              children: a.endTime
                            }
                          ),
                          /* @__PURE__ */ e(
                            u,
                            {
                              sx: {
                                position: "absolute",
                                right: 0,
                                width: 16,
                                borderTop: "1px solid",
                                borderColor: "divider"
                              }
                            }
                          )
                        ]
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ e(
                u,
                {
                  sx: {
                    flex: 1,
                    p: 1,
                    display: "flex",
                    minHeight: "100%"
                  },
                  children: a.component
                }
              )
            ]
          }
        )
      ] }, a.id);
    }) })
  ] });
}, fe = {
  500: "#9c27b0"
}, ke = ({
  title: r,
  subtitle: t,
  onClick: i,
  backgroundColor: n = fe[500]
}) => /* @__PURE__ */ o(
  u,
  {
    onClick: i,
    sx: {
      backgroundColor: n,
      color: "white",
      p: 1,
      borderRadius: 1,
      cursor: i ? "pointer" : "default",
      flex: 1,
      width: "100%",
      height: "100%",
      "&:hover": i ? {
        filter: "brightness(0.95)"
      } : void 0
    },
    children: [
      /* @__PURE__ */ e(D, { variant: "subtitle1", children: r }),
      t && /* @__PURE__ */ e(D, { variant: "body2", children: t })
    ]
  }
), Le = {
  CA: [
    {
      title: /* @__PURE__ */ o("p", { children: [
        "California ",
        /* @__PURE__ */ e("b", { children: "Drivers Ed" }),
        " Online"
      ] }),
      subtitle: "Join 46,000 other students who have enrolled in Coastline Academy Online Drivers Ed.",
      details: [
        "Earn your DMV Certificate",
        "Course approved by the California DMV",
        "Unlimited practice tests",
        "Video, images and text",
        "Fast and convenient",
        "Friendly customer support"
      ],
      url: "ca/course/drivers-ed"
    },
    {
      title: /* @__PURE__ */ o("p", { children: [
        "California Classroom ",
        /* @__PURE__ */ e("b", { children: "Drivers Ed" }),
        " - Fresno & Surrounding Areas Only"
      ] }),
      subtitle: "Join thousands of other students who have enrolled in Coastline Academy Drivers Ed.",
      details: [
        "Earn your DMV Certificate",
        "Course approved by the California DMV",
        "Unlimited practice tests",
        "Video, images and text",
        "Fast and convenient",
        "Friendly customer support"
      ],
      url: "ca/course/classroom-drivers-ed"
    }
    // {
    //   title: (
    //     <p>
    //       California <b>Traffic</b> School
    //     </p>
    //   ),
    //   subtitle:
    //     "Join thousands of other students who have purchased courses from Coastline Academy",
    //   details: [
    //     "Receive your Certificate of Completion",
    //     "Proof of completion sent automatically",
    //     "Approved by the California DMV",
    //     "Accepted by all California courts",
    //     "Video, images, and text",
    //     "Fast and convenient",
    //     "Friendly customer support",
    //   ],
    //   url: "ca/course/traffic-school",
    // },
  ],
  CO: [
    {
      title: /* @__PURE__ */ o("p", { children: [
        "Colorado ",
        /* @__PURE__ */ e("b", { children: "Drivers Ed" }),
        " Online"
      ] }),
      subtitle: "Join 46,000 other students who have enrolled in Coastline Academy Online Drivers Ed.",
      details: [
        "Unlock your Learner's Permit",
        "Course approved by the Colorado DMV",
        "Video, images and text",
        "Use any device: mobile, tablet, computer",
        "Friendly customer support"
      ],
      url: "co/course/drivers-ed"
    },
    {
      title: /* @__PURE__ */ o("p", { children: [
        "Colorado Classroom ",
        /* @__PURE__ */ e("b", { children: "Drivers Ed" }),
        " - Arvada & Surrounding Areas Only"
      ] }),
      subtitle: "Join us in-person at our Arvada location to complete your Drivers Ed course.",
      details: [
        "Complete DMV Requirements",
        "Course approved by the Colorado DMV",
        "Video, images and text",
        "Professional driving instructor",
        "Friendly customer support"
      ],
      url: "co/course/classroom-drivers-ed"
    },
    {
      title: /* @__PURE__ */ o("p", { children: [
        "Colorado Classroom ",
        /* @__PURE__ */ e("b", { children: "Drivers Ed" }),
        " - Littleton & Surrounding Areas Only"
      ] }),
      subtitle: "Join us in-person at our Littleton location to complete your Drivers Ed course.",
      details: [
        "Complete DMV Requirements",
        "Course approved by the Colorado DMV",
        "Video, images and text",
        "Professional driving instructor",
        "Friendly customer support"
      ],
      url: "co/course/classroom-drivers-ed-littleton"
    }
  ],
  IL: [
    {
      title: /* @__PURE__ */ o("p", { children: [
        "Illinois ",
        /* @__PURE__ */ e("strong", { children: "Classroom Teen Driver" }),
        " program"
      ] }),
      subtitle: "Join our classroom Teen Driver Program to start earning your license.",
      details: [
        "Course approved by the Illinois DMV",
        "Friendly customer support"
      ],
      url: "il/course/drivers-ed"
    }
  ],
  IN: [
    {
      title: /* @__PURE__ */ o("p", { children: [
        "Indiana ",
        /* @__PURE__ */ e("b", { children: "Drivers Ed" }),
        " Online"
      ] }),
      subtitle: "We've joined forces with Driving Brilliance to offer you a premium online course experience approved by the BMV.",
      details: [
        "Course approved by the Indiana BMV",
        "Video, images and text",
        "Fast and convenient",
        "Friendly customer support"
      ],
      url: "in/course/drivers-ed"
    }
  ],
  MO: [
    {
      title: /* @__PURE__ */ o("p", { children: [
        "Missouri ",
        /* @__PURE__ */ e("b", { children: "Drivers Ed" }),
        " Online"
      ] }),
      subtitle: "Join 46,000 other students who have enrolled in Coastline Academy Online Drivers Ed.",
      details: [
        "Video, images and text",
        "Fast and convenient",
        "Friendly customer support"
      ],
      url: "mo/course/drivers-ed"
    }
  ],
  NV: [
    {
      title: /* @__PURE__ */ o("p", { children: [
        "Nevada ",
        /* @__PURE__ */ e("b", { children: "Drivers Ed" }),
        " Online"
      ] }),
      subtitle: "Join 46,000 other students who have enrolled in Coastline Academy Online Drivers Ed.",
      details: [
        "Earn your DMV Certificate",
        "Course approved by the Nevada DMV",
        "Video, images and text",
        "Fast and convenient",
        "Friendly customer support"
      ],
      url: "nv/course/drivers-ed"
    }
  ],
  PA: [
    {
      title: /* @__PURE__ */ o("p", { children: [
        "Pennsylvania ",
        /* @__PURE__ */ e("b", { children: "Drivers Ed" }),
        " Online"
      ] }),
      subtitle: "Coming soon!",
      details: [],
      url: "pa/course/drivers-ed"
    }
  ],
  TX: [
    {
      title: /* @__PURE__ */ o("p", { children: [
        "Texas 32-Hour ",
        /* @__PURE__ */ e("b", { children: "Drivers Ed" }),
        " Course"
      ] }),
      isMostPopular: !0,
      details: [
        "For Teens Ages 14-17",
        "Self-Paced Course",
        "14 Hours of Professional Driving Instruction Required (7 hours driving + 7 hours observing)",
        "Shared Lessons Start at Designated Meeting Points"
      ],
      url: "tx/course/drivers-ed"
    },
    {
      title: /* @__PURE__ */ o("p", { children: [
        "Texas Parent-Taught ",
        /* @__PURE__ */ e("b", { children: "Drivers Ed" }),
        " Course"
      ] }),
      details: [
        "For Teens Ages 14-17",
        "Self-Paced Course",
        "Parent-Led Driving Instruction",
        "Professional Behind-the-Wheel Instruction Optional, but Recommended",
        "Private Lessons with Home Pickup Available"
      ],
      url: "tx/course/parent-taught"
    },
    {
      title: /* @__PURE__ */ o("p", { children: [
        "Texas 6-Hour Adult ",
        /* @__PURE__ */ e("b", { children: "Drivers Ed" }),
        " Course"
      ] }),
      details: [
        "For Adults 18+",
        "Self-Paced Course",
        "Professional Behind-the-Wheel Instruction Optional, but Recommended",
        "Private Lessons with Home Pickup Available"
      ],
      url: "tx/course/adult-drivers-ed"
    },
    {
      title: /* @__PURE__ */ o("p", { children: [
        "Texas 24-Hour Classroom ",
        /* @__PURE__ */ e("b", { children: "Drivers Ed" }),
        " - Mansfield & Surrounding Areas Only"
      ] }),
      details: [
        "For Teens Ages 14-17",
        "In-person in our Mansfield Office",
        "Includes permit test",
        "Shared Lessons Start at Designated Meeting Points"
      ],
      url: "tx/course/classroom-drivers-ed",
      isClassroom: !0
    },
    {
      title: /* @__PURE__ */ o("p", { children: [
        "Texas 6-Hour Classroom ",
        /* @__PURE__ */ e("b", { children: "Adult Permit Class" }),
        " - Mansfield & Surrounding Areas Only"
      ] }),
      details: [
        "For Adults 18+",
        "In-person in our Mansfield Office",
        "Includes permit test",
        "Private lesson packages available"
      ],
      url: "tx/course/classroom-adult-drivers-ed-mansfield",
      isClassroom: !0
    },
    {
      title: /* @__PURE__ */ o("p", { children: [
        "Texas 24-Hour Classroom ",
        /* @__PURE__ */ e("b", { children: "Drivers Ed" }),
        " - Richmond & Surrounding Areas Only"
      ] }),
      details: [
        "For Teens Ages 14-17",
        "In-person in our Richmond Office",
        "Includes permit test",
        "Shared Lessons Start at Designated Meeting Points"
      ],
      url: "tx/course/classroom-drivers-ed-richmond",
      isClassroom: !0
    },
    {
      title: /* @__PURE__ */ o("p", { children: [
        "Texas 6-Hour Classroom ",
        /* @__PURE__ */ e("b", { children: "Adult Permit Class" }),
        " - Richmond & Surrounding Areas Only"
      ] }),
      details: [
        "For Adults 18+",
        "In-person in our Richmond Office",
        "Includes permit test",
        "Private lesson packages available"
      ],
      url: "tx/course/classroom-adult-drivers-ed-richmond",
      isClassroom: !0
    },
    {
      title: /* @__PURE__ */ o("p", { children: [
        "Texas 24-Hour Classroom ",
        /* @__PURE__ */ e("b", { children: "Drivers Ed" }),
        " - Fort Worth & Surrounding Areas Only"
      ] }),
      details: [
        "For Teens Ages 14-17",
        "In-person in our Fort Worth Office",
        "Includes permit test",
        "Shared Lessons Start at Designated Meeting Points"
      ],
      url: "tx/course/classroom-drivers-ed-ftworth",
      isClassroom: !0
    },
    {
      title: /* @__PURE__ */ o("p", { children: [
        "Texas 6-Hour Classroom ",
        /* @__PURE__ */ e("b", { children: "Adult Permit Class" }),
        " - Fort Worth & Surrounding Areas Only"
      ] }),
      details: [
        "For Adults 18+",
        "In-person in our Fort Worth Office",
        "Includes permit test",
        "Private lesson packages available"
      ],
      url: "tx/course/classroom-adult-drivers-ed-ftworth",
      isClassroom: !0
    }
  ]
};
function Be(r, t) {
  const i = B();
  E(() => {
    i.current = r;
  }, [r]), E(() => {
    function n() {
      i.current();
    }
    const s = setInterval(n, t);
    return () => clearInterval(s);
  }, [t]);
}
export {
  Pe as ActionDialog,
  Le as COURSE_CONTENTS,
  Oe as Calendar,
  ue as CalendarType,
  Me as CollapsibleAlert,
  Fe as ConfirmationDialog,
  ke as GenericTimelineEvent,
  Te as Table,
  Ve as Timeline,
  Be as useInterval,
  Ee as useModal,
  P as withModalTargetSafe
};
